          const dataTextLoopLoading = document.querySelector('#data-text-looploading');
    

          function barLoadMore(pageNumber,productsCount,dataTextLoopLoading) {
            var dataTextLoopLoadingShowNumberOfProductsContent = dataTextLoopLoading.getAttribute('data-show-number-products-text');
            var dataTextLoopLoadingFromNumberOfProductsContent = dataTextLoopLoading.getAttribute('data-show-from-number-products-text');
            var dataTextLoopLoadingWatchedContent = dataTextLoopLoading.getAttribute('data-watched-from-number-products-text');
  
            var dataTextLoopLoadingLoadBeforeContent = dataTextLoopLoading.getAttribute('data-loadbefore-text');
            var dataTextLoopLoadingLoadMoreContent = dataTextLoopLoading.getAttribute('data-loadmore-text');
            const pageNumberInProducts = document.querySelector('#page-number-in-products');
            const loadMoreHeaderChange = document.querySelector('#load-more-header-change');

            
 
            
            const sliderProductBox = document.querySelector('.in-box-silder-page');
            if((productsCount/44) <= 1){
              
              pageNumberInProducts.innerHTML = `${dataTextLoopLoadingWatchedContent} ${productsCount} ${dataTextLoopLoadingFromNumberOfProductsContent} ${productsCount}`;
              loadMoreHeaderChange.innerHTML = `${dataTextLoopLoadingShowNumberOfProductsContent} ${productsCount} ${dataTextLoopLoadingFromNumberOfProductsContent} ${productsCount}`;
              loadmore.style = "display: none;";
              sliderProductBox.style = `width: 100%`
            }else{
              
              if((44*parseInt(pageNumber)) < productsCount){
                // pageNumberInProducts.innerHTML = productsCount  + '/' + (44*parseInt(pageNumber));
                pageNumberInProducts.innerHTML =  `${dataTextLoopLoadingWatchedContent} ${(44*parseInt(pageNumber))} ${dataTextLoopLoadingFromNumberOfProductsContent} ${productsCount}`;
                loadMoreHeaderChange.innerHTML =  `${dataTextLoopLoadingShowNumberOfProductsContent} ${(44*parseInt(pageNumber))} ${dataTextLoopLoadingFromNumberOfProductsContent} ${productsCount}`;
                loadmore.classList.add("button-loadding-prodcuts");
                loadmore.innerHTML = dataTextLoopLoadingLoadMoreContent;
                const pageNumberInProductsInPresents = ((44*parseInt(pageNumber))/productsCount) * 100;
                sliderProductBox.style = `width: ${pageNumberInProductsInPresents}%`
              }else{
                pageNumberInProducts.innerHTML =  `${dataTextLoopLoadingWatchedContent} ${productsCount}  ${dataTextLoopLoadingFromNumberOfProductsContent} ${productsCount}`;
                loadMoreHeaderChange.innerHTML =  `${dataTextLoopLoadingShowNumberOfProductsContent} ${productsCount}  ${dataTextLoopLoadingFromNumberOfProductsContent} ${productsCount}`;
                
                sliderProductBox.style = `width: 100%`
                loadmore.style = "display: none;";
                
              }
            }
          }
          function barLoadBefore(pageNumber,lastPageNumberLoadBeforeClick) {
            const pageNumberInProducts = document.querySelector('#page-number-in-products');
            const loadMoreHeaderChange = document.querySelector('#load-more-header-change');
            
            if(pageNumber >= 1 && lastPageNumberLoadBeforeClick >= 1){
              // loadbefore.
            }
          }

          
          function getBeforePage(type) {
                var currentUrl = window.location.href;
                var parsedUrl = new URL(currentUrl);
                parsedUrl.hash = '';
                  var urlParams = new URLSearchParams(parsedUrl.search);
                if (urlParams.has('page')) {
                  var pageNumber = urlParams.get('page');            
                  if(type == "static"){
                      var pageNumber = urlParams.get('page');
                      if(parseInt(pageNumber) > 1){
                        loadbefore.setAttribute("data-before-pagenumber", parseInt(pageNumber)-1);
                        loadbefore.style.display = "inline";

                      }else{
                        return 1;
                      }
                    
                  }else if(type == "click"){
                    
                     const lastPageBeforeNumber = loadbefore.getAttribute("data-before-pagenumber");
                     if(lastPageBeforeNumber >= 1){
                        const lastPageBeforeNumberLes = parseInt(lastPageBeforeNumber)-1
                        loadbefore.setAttribute("data-before-pagenumber", lastPageBeforeNumberLes);
                        var params = parsedUrl.searchParams;
                        params.set('page', lastPageBeforeNumber);
                        var lastPageUrlPage = parsedUrl.toString();
                     
                       
                        return lastPageUrlPage;
                       
                      }else{
                        loadbefore.style.display = "none"
                      }
                  
                  }
                }else{
                  loadbefore.style.display = "none"
                }
        }
          function checkPage() {
            
            const productsCount = loadmore.getAttribute("data-products-count");
            var currentUrl = window.location.href;
            var parsedUrl = new URL(currentUrl);
            parsedUrl.hash = ''; // rm hash #
            
            console.log(productsCount);
            if(productsCount <= 44){
              // barLoadMore()
              barLoadMore(0,productsCount,dataTextLoopLoading);
              return false;
            }else{
              if(loadmore.getAttribute("data-next-link") == "first_load"){
                
                var urlParams = new URLSearchParams(parsedUrl.search);
              
                if (urlParams.has('page')) {
                    var pageNumber = urlParams.get('page');
                    barLoadMore(pageNumber,productsCount,dataTextLoopLoading,dataTextLoopLoading);
                    // console.log('Page number:', pageNumber);
                    var nextPage = parseInt(pageNumber) + 1;
                    var params = parsedUrl.searchParams;
                    params.set('page', nextPage);
                    var nextUrlPage = parsedUrl.toString();
                } else {
                    var nextPage = 2;
                    var params = parsedUrl.searchParams;
                    params.set('page', nextPage);
                    var nextUrlPage = parsedUrl.toString();
                    barLoadMore(1,productsCount,dataTextLoopLoading);
                }
                  
                
              }else{
                const elNextPage = loadmore.getAttribute("data-next-link");
                var nextUrlPage = elNextPage;
                
              }
              return nextUrlPage;
            }
    
          }

         checkPage();
        getBeforePage('static');
          document.addEventListener('click', function(event) {
            
            // checkPage();
                 const elMainProductListFirst = document.querySelector('#Infinite-Loop');
                  if (event.target.matches('#loadmore')) {
                      var nextUrlPage = checkPage();
                      const elNextPage = document.querySelector('.pagination a:last-of-type'); 
                      loadmore.innerHTML = `<div class="lds-ring"><div></div><div></div><div></div><div></div></div>`;
                      loadmore.classList.remove("button-loadding-prodcuts");
                        
                      const elMainCollection = document.querySelector("div.collection");
                      
                        
                        fetch(nextUrlPage)
                        .then(response => {
                          if (!response.ok) {
                            throw new Error(`HTTP error! status: ${response.status}`);
                          }
                          
                          return response.text();
                        })
                        .then(html => {
                            const parser = new DOMParser();
                            const docNextPage =  parser.parseFromString(html, 'text/html');
                            const nextPageDataProduct = docNextPage.querySelectorAll('.grid-product');
                          
                           
                            
                          
                            nextPageDataProduct.forEach((key) => {
                              
                              key.querySelectorAll(".image-element").forEach((key2) => {
                                
                                //grid-product__content
                                key2.style = "opacity: 1;"
                                key2.classList.add();
                                
                                // console.log(key2);
  
                               
                              });
                              //grid-product__content
                              console.log(key);
                              elMainProductListFirst.append(key);
                              key.setAttribute("data-from-page",nextUrlPage);
                            });
   
                            var parsedUrl = new URL(nextUrlPage);
                            var urlParams = new URLSearchParams(parsedUrl.search);
                            var pageNumber = urlParams.get('page');
                            var params = parsedUrl.searchParams;
                             history.replaceState(null, null, parsedUrl.href); 
                            newNextPage = parseInt(pageNumber) + 1;
                            // Change 'page' 
                            params.set('page', newNextPage);

                              
                            var newNextUrlPage = parsedUrl.toString();
                            loadmore.setAttribute("data-next-link", newNextUrlPage);
                            const productsCount = loadmore.getAttribute("data-products-count");
                            const pageNumberInProducts = document.querySelector('page-number-in-products');
                             barLoadMore(pageNumber,productsCount,dataTextLoopLoading);
                         
                        })
                        .catch(e => console.log('Error:', e));
                  }else if (event.target.matches(".image-element")) {
                        var mainDivProduct = event.target.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement;
                        var urlHistory = `${mainDivProduct.getAttribute("data-from-page")}#${mainDivProduct.id}`;
                        if(mainDivProduct.getAttribute("data-from-page") !== null){
                          // alert(urlHistory);
                          history.replaceState(null, null, urlHistory); 
                          // const acspe = event.target.parentElement.className;
                          //   var cspe = acspe.split(' ')[1]
                          //   const scrollPosition = window.scrollY;
                          //   localStorage.setItem("scrollPosition", cspe);
                        }else{
                          var urlHistory = `#${mainDivProduct.id}`;
                          var currentUrl = window.location.href;
                          var parsedUrl = new URL(currentUrl);
                          parsedUrl.hash = mainDivProduct.id;
                          parsedUrl.page = mainDivProduct.id;
                          history.replaceState(null, null, parsedUrl.toString()); 
                        }
                 }else if(event.target.matches("#loadbefore")){
                      var beforeUrlPage = getBeforePage('click');
                      
                   
                        if(beforeUrlPage != 1){
                          loadbefore.innerHTML = `<div class="lds-ring"><div></div><div></div><div></div><div></div></div>`;
                            
                             fetch(beforeUrlPage)
                              .then(response => {
                                if (!response.ok) {
                                  throw new Error(`HTTP error! status: ${response.status}`);
                                }
                                return response.text();
                              })
                              .then(html => {
                                  
                                  const parser = new DOMParser();
                                  const docNextPage =  parser.parseFromString(html, 'text/html');
                                  const beforePageDataProduct = docNextPage.querySelectorAll('.grid-product');
                                  let elementsToInsert = [];
                                  beforePageDataProduct.forEach((key) => {
                                    key.querySelectorAll(".image-element").forEach((key2) => {
                                        key2.style = "opacity: 1;"
                                        key2.classList.add();
                                       
                                      });
                                    elementsToInsert.push(key);
                                     key.setAttribute("data-from-page",beforeUrlPage);
                                      });
                                
                                  if(loadbefore.getAttribute("data-before-pagenumber") <= 0){
                                      loadbefore.style.display = "none"
                                    }
                                 var dataTextLoopLoadingLoadBeforeContent = dataTextLoopLoading.getAttribute('data-loadbefore-text');

                                  loadbefore.innerHTML = dataTextLoopLoadingLoadBeforeContent;
                                  elementsToInsert.reverse();
                              
                                  
                                  elementsToInsert.forEach((element) => {
                                      elMainProductListFirst.insertBefore(element, elMainProductListFirst.childNodes[0]);
                                  });
                                
                                 // window.scrollTo(scrollPositionAfterClick);
                                                                scrollToId(elementsToInsert[0].id);
                            });
                            

                        }else{
                          
                        }
                     
                    
                  }
                  
                  
    });
   if (history.scrollRestoration) {
     var browserAndDevice = detectBrowserAndDevice();

      if(browserAndDevice.isSafari){
        
        history.scrollRestoration = 'auto';
      }else{
        history.scrollRestoration = "manual";
      }
    }
    const scrollRestoration = history.scrollRestoration;
      if (scrollRestoration === "manual") {
        scrollToHash();
      }

   function detectBrowserAndDevice() {
        var userAgent = navigator.userAgent;
        var isSafari = /^((?!chrome|android).)*safari/i.test(userAgent);
        var isMobile = /iPhone|iPad|iPod|Android/i.test(userAgent);
    
        return {
            isSafari: isSafari,
            isMobile: isMobile
        };
    }
    function scrollToHash() {
      const hash = window.location.hash;
      if (hash) {
        // Remove the '#' from the hash
        const elementId = hash.substring(1);
        const element = document.getElementById(elementId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    }
    function scrollToId(elementId) {
        const element = document.getElementById(elementId);
        if (element) {
            element.scrollIntoView({
                block: 'start',     
                inline: 'nearest' 
            });
        } else {
            console.log('Element with ID ' + elementId + ' not found');
        }
    }

